import Vue from 'vue'
import NavBar from './components/NavBar.vue';
import DistributionPointsTabPanel from './components/DistributionPointsTabPanel.vue';
import LoginComponent from './components/LoginModalComponent/LoginComponent.vue';
import FooterComponent from './components/FooterComponent.vue';
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

var navBarComponent;
navBarComponent = new Vue({
  el: '#navBarComponent',
  router,
  components: {NavBar, DistributionPointsTabPanel, FooterComponent},
  template: '<div><NavBar/><FooterComponent/></div>',
});

// var loginComponent;
// loginComponent = new Vue({
//   el: '#loginComponent',
//   router,
//   components: {LoginComponent},
//   template: '<LoginComponent/>',
// });

export default Vue;



// WEBPACK FOOTER //
// ./src/main.js